// Hook to use real viewport height on mobile
import { useEffect } from 'react';

const useViewportHeight = () => {
  useEffect(() => {
    // Verifica se está em um ambiente onde window e document estão disponíveis
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const setRealVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setRealVH();
    window.addEventListener('resize', setRealVH);

    return () => window.removeEventListener('resize', setRealVH);
  }, []);
};

export default useViewportHeight;